import React from 'react'

function Test()
{
    // const sectionRef = useRef(null);
    // const [expandSection, setExpandSection] = useState(false);

    // Retrieve skill info from database
    // skillData = RetrieveSkillInfoFromDatabase();

    // const skillItemsToShow = 4;
    // const languages = skillData.map((info, index) =>
    // {
    //     return <>
    //         <RatingCard
    //             expand={false}
    //             title={info.title}
    //             rating={info.level}
    //             tip={<><Icon.Clock style={{ filter: 'drop-shadow(1px 1px 0px black' }} /> {info.time}</>}
    //             icon={<img src={info.icon} title={''} style={{ alignSelf: 'center', height: height, verticalAlign: 'middle' }} />}
    //             desc={info.description === "" || info.description == null ? 'No description for this yet...' : info.description}
    //             hidden={(index >= skillItemsToShow ? !expandSection : false)}
    //         />
    //     </>
    // })

    return (
        // { languages }
        <div>Test</div>
    )
}

export default Test